// extracted by mini-css-extract-plugin
export var formContainer = "_l7-0";
export var message = "_l7-1";